import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { MaterialModal } from 'components/layout'

@injectIntl
class AssessorMissingModal extends Component {
  static propTypes = {
    intl: PropTypes.object,
    modalId: PropTypes.string,
    onClose: PropTypes.func,
    openJourneyOverview: PropTypes.func,
    hasSupervisor: PropTypes.bool
  }

  handleEdit = () => {
    this.props.onClose()
    setTimeout(() => {
      this.props.openJourneyOverview({ missingData: true })
    }, 500)
  }

  render() {
    const { modalId, hasSupervisor, intl } = this.props
    const role = hasSupervisor
      ? intl.formatMessage({
          id: 'roles.supervisor',
          defaultMessage: 'Supervisor'
        })
      : intl.formatMessage({ id: 'roles.assessor', defaultMessage: 'Assessor' })

    return (
      <MaterialModal.Body
        title="Missing data"
        titleKey="moduleTitle.missing_data"
        id={modalId}
      >
        <MaterialModal.Content>
          <p className="desc">
            <FormattedMessage
              id="errors.there_are_currently_no_details_for_your"
              defaultMessage="There are currently no details for your {role}. Please fill in the missing details before submitting your Activity for assessment"
              values={{
                role
              }}
            />
          </p>
        </MaterialModal.Content>
        <MaterialModal.Footer
          action="Edit"
          actionKey="button.edit"
          insideContent
          onClick={this.handleEdit}
        />
      </MaterialModal.Body>
    )
  }
}

export default AssessorMissingModal
